import styled, { keyframes } from "styled-components";
import { themeGet } from "@styled-system/theme-get";

export const GradientBorder = styled.div`
  background: linear-gradient(to right, rgb(203, 83, 203), rgb(114, 114, 221));
  padding: 1px;
  border-radius: ${themeGet("radii.2")};
  width: 100%;
`;

export const ToggleButton = /** @type {typeof styled.button<{isCollapsed?: boolean}>} */ (
  styled.button
)`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  background: none;
  cursor: pointer;
  color: ${themeGet("colors.greyDarkest")};
  font-family: ${themeGet("fonts.main")};
  font-size: ${themeGet("fontSizes.1")};
  font-weight: ${themeGet("fontWeights.2")};
  padding: ${({ isCollapsed }) => (isCollapsed ? "6px 7px" : "0 1px")};
  border-radius: ${themeGet("radii.2")};
  &:hover,
  &:focus {
    outline: none;
    background: ${({ isCollapsed }) =>
      isCollapsed
        ? "linear-gradient(to right, rgb(255, 240, 255), rgb(240, 240, 255))"
        : "none"};
  }
`;

export const Content = /** @type {typeof styled.div<{isCollapsed?: boolean}>} */ (
  styled.div
)`
  background: linear-gradient(to right, rgb(255, 248, 255), rgb(248, 248, 255));
  padding: ${({ isCollapsed }) => (isCollapsed ? "0" : themeGet("space.s"))};
  border-radius: ${themeGet("radii.2")};
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: ${themeGet("space.xs")};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-top: 8px;
    padding-bottom: 10px;
    a {
      font-size: inherit !important;
      font-weight: inherit !important;
    }
  }
`;

export const CollapsibleContent = /** @type {typeof styled.div<{collapsible?: string, isCollapsed?: boolean}>} */ (
  styled.div
)`
  display: ${({ collapsible, isCollapsed }) =>
    collapsible && isCollapsed ? "none" : "block"};
  overflow-x: auto;
  max-width: 100%;
`;

export const StyledToolCallBubble = styled.div`
  display: flex;
  padding: ${themeGet("space.s")};
  border-radius: ${themeGet("radii.2")};
  background-color: #eee;
`;

const typingAnimationKeyframes = keyframes`
 0% { opacity: 1; }
 50% { opacity: 0.25; }
 100% { opacity: 1; }
 `;

export const TypingIndicator = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: ${themeGet("colors.black")};
  border-radius: 50%;
  animation: ${typingAnimationKeyframes} 1.5s infinite ease-in-out;
`;
